<template>
  <div class="message">
    <div><h5>车牌登记系统管理中心</h5></div>
    <div>
      <van-divider content-position="left" :style="{color:'black',fontSize:'18px',fontSize:'16px',}">数据模块</van-divider>
      <van-row>
          <div class="imgBox sjtj" @click = "goDataCount">
            <van-row >
            <van-col :span="12">
              <img src="@/assets/dataCount.png" style="border-radius: 50%;vertical-align: middle;">
            </van-col>
            <van-col :span="8">
              <span>数据统计</span>
            </van-col>
          </van-row>   
          </div>
      </van-row>
      <van-row>
          <div class="imgBox sjcx" @click="goDataQuery">
            <van-row >
            <van-col :span="12">
              <img src="@/assets/query.png" style="border-radius: 50%;vertical-align: middle;">
            </van-col>
            <van-col :span="8">
              <span>数据查询</span>
            </van-col>
          </van-row>   
          </div>
      </van-row>
      <!-- <van-row>
          <div class="imgBox sjgl" @click="goWhiteList">
            <van-row>
            <van-col :span="12">
              <img src="@/assets/data.png" style="border-radius: 50%;vertical-align: middle;">
            </van-col>
            <van-col :span="8">
              <span>白名单</span>
            </van-col>
          </van-row>   
          </div>
      </van-row> -->
      <van-row>
          <div class="imgBox yhgl" @click="goManageUser">
            <van-row>
            <van-col :span="12">
              <img src="@/assets/user.png" style="border-radius: 50%;vertical-align: middle;">
            </van-col>
            <van-col :span="8">
              <span>用户管理</span>
              <!-- 车牌自取信息登记系统 -->
            </van-col>
          </van-row>   
          </div>
      </van-row>
      
    </div>
    <div style="margin: 16px;">
          <van-button round block plain hairline type="info" style="margin-top: 2%;" @click="exit">退出登录</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    // 退出
    exit(){
        localStorage.removeItem('Authorization')
        this.$router.push('/managerLogin')
      },
      // 数据统计
      goDataCount(){
        console.log('数据统计');
        this.$router.push('/dataCount')
      },
      // 数据查询
      goDataQuery(){
        console.log('数据查询');
        this.$router.push('/dataQuery')
      },
      // 白名单
      goWhiteList(){
        console.log('白名单');
        this.$router.push('/whiteList')
      },
      // 用户管理
      goManageUser(){
        console.log('管理员用户管理');
        this.$router.push('/user')
      }
    }
  }
</script>

<style lang="scss" scoped>
.message{
  width: 100vw;
  height: 100vh;
  .imgBox{
    margin: 2%;
    width: 95%;
    height: 110px;
    border-radius: 10px;
    line-height: 110px;
    color: white;
    font-size: 28px;
    background-size: cover; /* 背景图片覆盖整个容器 */
    background-repeat: no-repeat; /* 背景图片不重复 */
    background-clip: content-box; /* 背景裁剪到内容区域 */
    img{
      width: 85px;
      height: 85px;
    }
  }
  .sjtj{
    background-image: url('../../assets/sjtjbgc.jpg');
  }
  .sjcx{
    background-image: url('../../assets/sjcxbgc.jpg');
  }
  .sjgl{
    background-image: url('../../assets/sjglbgc.jpg');
  }
  .yhgl{
    background-image: url('../../assets/yhglbgc.jpg');
  }
  
  
}
</style>